import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQProps {
  items: FAQItem[];
}

export default function FAQ({ items }: FAQProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="space-y-3">
      {items.map((item, index) => (
        <div
          key={index}
          className="border border-background-200/70 rounded-lg overflow-hidden bg-background-50"
        >
          <button
            onClick={() => toggleFAQ(index)}
            className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-background-50 transition-colors"
          >
            <span className="text-sm font-medium text-foreground-950 pr-4">{item.question}</span>
            <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
              <i
                className={`ri-${
                  openIndex === index ? 'subtract' : 'add'
                }-line text-lg text-foreground-500 transition-transform duration-300`}
              ></i>
            </span>
          </button>
          <div
            className={`overflow-hidden transition-all duration-300 ${
              openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
            }`}
          >
            <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
              {item.answer}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}